/** Gün/gece döngüsü ve oyun takvimi. */

export type DayPhase = 'dawn' | 'day' | 'dusk' | 'night';

export interface TimeState {
  /** Oyun içi geçen toplam saniye (kaydedilir). */
  elapsed: number;
  /** Kaçıncı gün (1'den başlar). */
  day: number;
}

export class GameClock {
  /** Bir oyun gününün gerçek saniye cinsinden uzunluğu. */
  dayLength: number;
  private _elapsed = 0;
  private _day = 1;
  private _lastDay = 1;

  constructor(dayLength = 1200) {
    this.dayLength = dayLength;
  }

  get elapsed(): number {
    return this._elapsed;
  }
  get day(): number {
    return this._day;
  }
  /** Gün içindeki konum 0..1 (0 = gün doğumu). */
  get cycle(): number {
    return (this._elapsed % this.dayLength) / this.dayLength;
  }
  /** 0..24 arası oyun saati. */
  get hour(): number {
    return this.cycle * 24;
  }

  get phase(): DayPhase {
    const h = this.hour;
    if (h < 6) return 'dawn';
    if (h < 17) return 'day';
    if (h < 20) return 'dusk';
    return 'night';
  }

  get isNight(): boolean {
    const h = this.hour;
    return h >= 20 || h < 5;
  }

  /** Güneşin gökyüzündeki yükseklik oranı -1..1 (gölge/ışık şiddeti için). */
  get sunElevation(): number {
    return Math.sin((this.cycle - 0.25) * Math.PI * 2);
  }

  update(dt: number): { newDay: boolean } {
    this._elapsed += dt;
    this._day = 1 + Math.floor(this._elapsed / this.dayLength);
    const newDay = this._day !== this._lastDay;
    this._lastDay = this._day;
    return { newDay };
  }

  toJSON(): TimeState {
    return { elapsed: this._elapsed, day: this._day };
  }

  load(state: Partial<TimeState> | undefined): void {
    if (!state) return;
    if (Number.isFinite(state.elapsed)) this._elapsed = Math.max(0, state.elapsed as number);
    this._day = 1 + Math.floor(this._elapsed / this.dayLength);
    this._lastDay = this._day;
  }

  phaseLabel(): string {
    switch (this.phase) {
      case 'dawn':
        return 'Sabah';
      case 'day':
        return 'Gündüz';
      case 'dusk':
        return 'Akşam';
      default:
        return 'Gece';
    }
  }
}
